
export const SELECT_RELATION = 'SELECT_RELATION';
export const DESELECT_RELATION = 'DESELECT_RELATION';
export const SELECT_ORDER = 'SELECT_ORDER';
export const DESELECT_ORDER = 'DESELECT_ORDER';
export const SELECT_SHIPMENT = 'SELECT_SHIPMENT';
export const DESELECT_SHIPMENT = 'DESELECT_SHIPMENT';
export const SELECT_CARRIER = 'SELECT_CARRIER';
export const DESELECT_CARRIER = 'DESELECT_CARRIER';
export const SELECT_CONTACT = 'SELECT_CONTACT';
export const DESELECT_CONTACT = 'DESELECT_CONTACT';

export const DESELECT_ALL = 'DESELECT_ALL';


export const selectRelation = (relation) => ({
    type: SELECT_RELATION,    
    payload: relation    
});

export const deselectRelation = () => ({
    type: DESELECT_RELATION,    
});

export const selectOrder = (params) => ({
    type: SELECT_ORDER,    
    payload: params    
});
export const deselectOrder = () => ({
    type: DESELECT_ORDER,    
});

export const selectShipment = (params) => ({
    type: SELECT_SHIPMENT,    
    payload: params    
});

export const deselectShipment = () => ({
    type: DESELECT_SHIPMENT,     
});

export const selectCarrier = (params) => ({
    type: SELECT_CARRIER,    
    payload: params    
});

export const deselectCarrier = () => ({
    type: DESELECT_CARRIER,     
});

export const selectContact = (params) => ({
    type: SELECT_CONTACT,    
    payload: params    
});

export const deselectContact = () => ({
    type: DESELECT_CONTACT,     
});

export const deselectAll = () => ({
    type: DESELECT_ALL,     
});


// WEBPACK FOOTER //
// ./src/actions/select_actions.js